import { useSearchParams } from 'react-router-dom';
import { Payment } from 'types/user';
import { usePayByBankTransferModal } from './PayByBankTransferModal/usePayByBankTransferModal';
import { usePendingBankTransferModal } from './PendingBankTransferModal/usePendingBankTransferModal';
import { useEffect } from 'react';
import { Cart } from 'containers/Billing/types';
import { Plan } from 'types/plan';

export function usePendingTransferProps({
  paymentHistory,
  cart,
  subscribablePlans,
}: {
  cart: Cart;
  subscribablePlans: Plan[];
  paymentHistory: Payment[];
}) {
  const [searchParams] = useSearchParams();
  const receivedPayment = searchParams.get('received') === 'true';
  const { open: openPayByBankTransferModal } = usePayByBankTransferModal();
  const { open: openPendingModal } = usePendingBankTransferModal();

  useEffect(() => {
    if (paymentHistory.length === 0 || receivedPayment) return;

    const hasSomePendingPayments = paymentHistory.some(
      p => p.paymentStatus === 'pending',
    );
    if (hasSomePendingPayments) {
      openPendingModal();
    }
  }, [paymentHistory, receivedPayment]);

  return {
    openPayByBankTransferModal() {
      return openPayByBankTransferModal({
        cart,
        plans: subscribablePlans,
      });
    },
  };
}
